import React, { useEffect, useState } from "react";
import Parse from "../../api/ApiConfig";
import { useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CompletedLeaseForm from "./sections/CompletedLeaseForm";
import OngoingLeaseForm from "./sections/OngoingLeaseForm";
import RequestLeaseForm from "./sections/RequestLeaseForm";
import CreatedAssetsForm from "./sections/CreatedAssetsForm";
import { fetchInvestorAsset, fetchLeaseObject, fetchSavingsObject } from "./utils";
import SavingsForm from "./sections/SavingsForm";
import { FormContainer } from "../../components/Form/FormComponents.styled";
import InvestorAssetForm from "./sections/InvestorAssetForm";
import QuickLeaseAssetForm from "./sections/QuickLeaseAssetForm";
import AssetRegistration from "./sections/AssetRegistration";
import InsureAsset from "./sections/InsureAsset";

/* eslint-disable no-unused-vars */
const SingleLease = () => {
	let { category, id: LeaseId } = useParams();
	const [profileFilter, loading, setLoading] = useOutletContext();
	const [leaseData, setLeaseData] = useState(null);

	const getLeaseObject = async () => {
		let data;
		// Fetch Lease object
		if (profileFilter == "investor" || profileFilter == "quick_lease") {
			data = await fetchInvestorAsset(LeaseId, profileFilter);
		} else if (category === "savings") {
			data = await fetchSavingsObject(LeaseId);
		} else {
			data = await fetchLeaseObject(LeaseId);
		}

		// Handle response data
		if (data && !data?.error) {
			setLoading(false);
			setLeaseData(data.result);
		} else {
			setLoading(false);
			setLeaseData(data);
			toast.error(data?.error || "Error fetching data!");
		}
	};

	const updateLeaseObject = async (formData) => {
		setLoading(true);
		console.log(category, formData);
		try {
			let Lease, data;

			if (profileFilter == "investor" || profileFilter == "quick_lease") {
				Lease = Parse.Object.extend("Asset");
				data = {
					leaseStructure: formData.leaseStructure,
					leaseDuration: formData.leaseDuration,
					amountToInvest: formData.amountToInvest,
					waitingPeriod: formData.waitingPeriod,
				};
			} else {
				Lease = Parse.Object.extend("Lease");
				data = {
					leaseType: formData.leaseType,
					leaseStructure: formData.leaseStructure,
					leaseDuration: formData.leaseDuration,
					paymentType: formData.paymentType,
					delivery_fee: formData.delivery_fee,
					deliveryType: formData.deliveryType,
					delivery_status: formData.delivery_status,
					paymentStatus: formData.paymentStatus,
				};
			}

			const LeaseObject = new Lease();
			LeaseObject.id = LeaseId;

			// Save all fields except productId and userId
			LeaseObject.save(data).then((result) => {
				console.log("LeaseObject updated:", result);
				setLoading(false);
				toast.success("Lease updated successfully!");
			});
		} catch (error) {
			console.log(error);
			setLoading(false);
			toast.error("Error updating Lease!");
		}
	};

	// On page load
	useEffect(() => {
		setLoading(true);
		getLeaseObject();
	}, [category]);

	const CurrentLeaseForm = (props) => {
		if (category === "ongoing") {
			return <OngoingLeaseForm {...props} />;
		} else if (category === "submitted") {
			return <RequestLeaseForm {...props} />;
		} else if (category === "completed") {
			return <CompletedLeaseForm {...props} />;
		} else if (category === "asset_registration") {
			return <AssetRegistration {...props} />;
		} else if (category === "insurance") {
			return <InsureAsset {...props} />;
		} else if (category === "created_assets") {
			return <CreatedAssetsForm {...props} />;
		} else if (category === "savings") {
			return <SavingsForm {...props} />;
		} else if (profileFilter === "quick_lease") {
			return <QuickLeaseAssetForm {...props} />;
		} else if (category === "inactive" || category === "active" || category === "funded") {
			return <InvestorAssetForm {...props} />;
		} else {
			return <div className='text-center p-3'>[404] Error: Lease category not found!</div>;
		}
	};

	return (
		<FormContainer>
			{
				// Show CurrentLeaseForm if LeaseId is present and loading is false
				leaseData?.objectId && !loading ? (
					<CurrentLeaseForm
						leaseData={leaseData}
						setLeaseData={setLeaseData}
						updateLeaseObject={updateLeaseObject}
					/>
				) : leaseData?.error ? (
					<div className='text-center fw-500 p-3'>Error fetching data!</div>
				) : null
			}
		</FormContainer>
	);
};

export default SingleLease;
